module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "sec-9"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#con1",
      "id": "toc1"
    }
  }, [_c('i', [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#con2",
      "id": "toc2"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#con3",
      "id": "toc3"
    }
  }, [_vm._v("LIVING ALERT:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter04#con4",
      "id": "toc4"
    }
  }, [_c('i', [_vm._v("How to Hear a Heart Drop")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#con5",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WO")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#con6",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIND YOUR WHY:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#con7",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Pssst . . . It’s All about Relationships!")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#con8",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HREE")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#con10",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IT’S ABOUT TIME:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#con11",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Giving of Yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#con12",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUR")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#con13",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHO MAKES YOUR DAY:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#con14",
      "id": "toc14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Noticing the Necessary People")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#con15",
      "id": "toc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVE")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#con16",
      "id": "toc16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE SICK AT HEART:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#con17",
      "id": "toc17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("What to Say or Do When You Don’t Know What to Say or Do")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#con18",
      "id": "toc18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IX")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#con19",
      "id": "toc19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHIPPED CROCK-POTS AND STAINED CARPETS:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#con20",
      "id": "toc20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Living a Life of Welcome")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz9-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#con21",
      "id": "toc21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVEN")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#con22",
      "id": "toc22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE LONELY AND UNLOVED:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz9-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#con23",
      "id": "toc23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("How to Be Their Family and Bless Yours Too")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz10-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#con24",
      "id": "toc24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGHT")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz10-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#con25",
      "id": "toc25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CRANKY AND CANTANKEROUS:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz10-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#con26",
      "id": "toc26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("How to Love the Hard-to-Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz10-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#con27",
      "id": "toc27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INE")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz10-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#con28",
      "id": "toc28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NEAREST AND DEAREST:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz10-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#con29",
      "id": "toc29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("How to Really Care for Your Clan")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz10-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#con30",
      "id": "toc30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EN")]), _vm._v("—")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz10-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#con31",
      "id": "toc31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCATTER KINDNESS:")])]), _vm._v(" "), _c('p', {
    staticClass: "level2",
    attrs: {
      "id": "pz10-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#con32",
      "id": "toc32",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Other-Centered Living in a Self-Centered World")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "pz10-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#con33",
      "id": "toc33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONUS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATERIAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "AEQL"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#con34",
      "id": "toc34",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("MEMORY VERSES FOR MAKING A DIFFERENCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "Ae7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#con35",
      "id": "toc35",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("QUIPS AND QUOTABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "Apo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#con36",
      "id": "toc36",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("RECIPES FOR REACHING OUT")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "AeNo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#con37",
      "id": "toc37",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("GIFT TAGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "Aud"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#con38",
      "id": "toc38",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "level1",
    attrs: {
      "id": "Aqqt"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#con39",
      "id": "toc39",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("ABOUT KAREN")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0